import { MainnetChainIds } from 'constants/chains'

export const V3WithdrawalChainIds = [
  MainnetChainIds.BSC,
  MainnetChainIds.Polygon,
  MainnetChainIds.Avalanche,
  MainnetChainIds.Arbitrum,
  MainnetChainIds.Optimism,
  MainnetChainIds.zkSyncEra,
  MainnetChainIds.Linea,
  MainnetChainIds.Base,
  MainnetChainIds.opBNB,
] as const

export const V3WithdrawalChainRpcMap = {
  [MainnetChainIds.zkSyncEra]: 'https://mainnet.era.zksync.io',
  [MainnetChainIds.Linea]: 'https://rpc.linea.build',
  [MainnetChainIds.BSC]: 'https://rpc.ankr.com/bsc',
  [MainnetChainIds.Arbitrum]: 'https://rpc.ankr.com/arbitrum',
  [MainnetChainIds.Polygon]: 'https://rpc.ankr.com/polygon',
  [MainnetChainIds.Avalanche]: 'https://rpc.ankr.com/avalanche',
  [MainnetChainIds.Optimism]: 'https://rpc.ankr.com/optimism',
  [MainnetChainIds.Base]: 'https://mainnet.base.org',
  [MainnetChainIds.opBNB]: 'https://opbnb-mainnet-rpc.bnbchain.org',
} as const

export const V3WithdrawalMulticall = {
  [MainnetChainIds.zkSyncEra]: '0xe06A5E9e4fEDb7f78ef65572607A6A702c91556A',
  [MainnetChainIds.Linea]: '0xEb79fe8d1D8cc146FF12F3E99AF4EE39e239f4AD',
  [MainnetChainIds.BSC]: '0xebdA7f097EF976e8E82FA11F05ef1906f3068105',
  [MainnetChainIds.Arbitrum]: '0xa005091c98e6793b90E1340Bbd36C5d6De36fB60',
  [MainnetChainIds.Polygon]: '0xf4FE03b2A77ce8d5695507e7c11CBaCb3a2DD32a',
  [MainnetChainIds.Avalanche]: '0x53D9D2C059D35904Ce1dAbFbBFc41a89D3C6dB6A',
  [MainnetChainIds.Optimism]: '0x87743f9CccA4a6DFbFfB2856dC6839b1919a43FB',
  [MainnetChainIds.Base]: '0x98CEDA04E4a1FDc0fd025FB73e48e609AD00673B',
  [MainnetChainIds.opBNB]: '0xb908A530f4c0D4725f5Bde994870AC3f75Fa2a42',
} as const

export const V3WithdrawalNetworks = {
  [MainnetChainIds.zkSyncEra]: {
    name: 'zkSync Era',
    chainId: '0x144',
    layerTwoChainId: 5,
    symbol: 'ETH',
    decimals: 18,
    explorerUrl: 'https://explorer.zksync.io',
    iconUrl: 'http://app.zkex.com/icons/zksync.svg',
  },
  [MainnetChainIds.Linea]: {
    name: 'Linea',
    chainId: '0xe708',
    layerTwoChainId: 7,
    symbol: 'ETH',
    decimals: 18,
    explorerUrl: 'https://lineascan.build',
    iconUrl: 'https://app.zkex.com/icons/linea.svg',
  },
  [MainnetChainIds.BSC]: {
    name: 'BNB Smart Chain',
    chainId: '0x38',
    layerTwoChainId: 3,
    symbol: 'BNB',
    decimals: 18,
    explorerUrl: 'https://bscscan.com',
    iconUrl: 'https://app.zkex.com/icons/bsc.svg',
  },
  [MainnetChainIds.Arbitrum]: {
    name: 'Arbitrum One',
    chainId: '0xa4b1',
    layerTwoChainId: 9,
    symbol: 'ETH',
    decimals: 18,
    explorerUrl: 'https://arbiscan.io',
    iconUrl: 'https://app.zkex.com/icons/arb.svg',
  },
  [MainnetChainIds.Polygon]: {
    name: 'Polygon',
    chainId: '0x89',
    layerTwoChainId: 1,
    symbol: 'MATIC',
    decimals: 18,
    explorerUrl: 'https://polygonscan.com',
    iconUrl: 'https://app.zkex.com/icons/matic.svg',
  },
  [MainnetChainIds.Avalanche]: {
    name: 'Avalanche C-Chain',
    chainId: '0xa86a',
    layerTwoChainId: 2,
    symbol: 'AVAX',
    decimals: 18,
    explorerUrl: 'https://snowtrace.io',
    iconUrl: 'https://app.zkex.com/icons/avax.svg',
  },
  [MainnetChainIds.Optimism]: {
    name: 'Optimism',
    chainId: '0xa',
    layerTwoChainId: 10,
    symbol: 'ETH',
    decimals: 18,
    explorerUrl: 'https://optimistic.etherscan.io',
    iconUrl: 'https://app.zkex.com/icons/op.svg',
  },
  [MainnetChainIds.Base]: {
    name: 'Base',
    chainId: '0x2105',
    layerTwoChainId: 11,
    symbol: 'ETH',
    decimals: 18,
    explorerUrl: 'https://basescan.org',
    iconUrl: 'https://app.zkex.com/icons/base.svg',
  },
  [MainnetChainIds.opBNB]: {
    name: 'opBNB',
    chainId: '0xcc',
    layerTwoChainId: 15,
    symbol: 'BNB',
    decimals: 18,
    explorerUrl: 'https://mainnet.opbnbscan.com',
    iconUrl: 'https://app.zkex.com/icons/opbnb.svg',
  },
} as const

export const V3WithdrawalZkLinkChains = [
  {
    chainId: 1,
    chainType: 0,
    layerOneChainId: '0x89',
    mainContract: '0x94f2ebe929fe948f960908ec57e5d7792facac07',
    layerZeroContract: '0xe89635a7339bf46198f76b17bcfdad977699cc13',
    gasTokenId: 33,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 2,
    chainType: 0,
    layerOneChainId: '0xa86a',
    mainContract: '0xa005091c98e6793b90e1340bbd36c5d6de36fb60',
    layerZeroContract: '0x9dc75660523581d56d4c8efd5819161e15bbc88c',
    gasTokenId: 34,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 3,
    chainType: 0,
    layerOneChainId: '0x38',
    mainContract: '0x1ee09a2caa0813a5183f90f5a6d0e4871f4c6002',
    layerZeroContract: '0x028781ceed4a2264466ef5ab73c91603087fa131',
    gasTokenId: 35,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 5,
    chainType: 0,
    layerOneChainId: '0x144',
    mainContract: '0x46d6e42fb6e04695156b5ad38a3ec6fa9c59147d',
    layerZeroContract: '0x66d4ff37b0c908cd3cf02e9ba8796073d914029e',
    gasTokenId: 36,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 7,
    chainType: 0,
    layerOneChainId: '0xe708',
    mainContract: '0x3e98568770af932353a2a8c3e3b77cdb7f0c2fa1',
    layerZeroContract: '0xff73a1a1d27951a005eb23276dc99cb7f8d5420a',
    gasTokenId: 36,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 9,
    chainType: 0,
    layerOneChainId: '0xa4b1',
    mainContract: '0xed5d1e1320720cae8bb40275550a7d307a082ac3',
    layerZeroContract: '0x9dc75660523581d56d4c8efd5819161e15bbc88c',
    gasTokenId: 36,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 10,
    chainType: 0,
    layerOneChainId: '0xa',
    mainContract: '0xee7981c4642de8d19aed11da3bac59277dfd59d7',
    layerZeroContract: '0x62351b47e060c61868ab7e05920cb42bd9a5f2b2',
    gasTokenId: 36,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 11,
    chainType: 0,
    layerOneChainId: '0x2105',
    mainContract: '0x161f4baab4052f20f5f4347ec4422556aa0477f0',
    layerZeroContract: '0x3545fb62209935ab6038f3a1b40403ddffe6e49c',
    gasTokenId: 36,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 15,
    chainType: 0,
    layerOneChainId: '0xcc',
    mainContract: '0x3c3f4b866f8c6f0d2c912fee36d5ad337a9aa98e',
    layerZeroContract:
      '0x0000000000000000000000000000000000000000000000000000000000000000',
    gasTokenId: 35,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
] as const
